import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styles from './SellerUniversity.module.css';
import ChatInterface from '../components/ChatInterface';
import { addUserMessage, sendMessageAsync } from '../features/chat/chatSlice';

const SUGGESTED_QUESTIONS = [
  'How can I improve my product listing?',
  'What are the latest trends in my category?',
  'How is my brand performing this month?',
  'What news is relevant to my category?',
];

const RECOMMENDATIONS = [
  { id: 1, text: 'Complete your brand profile for tailored insights.' },
  { id: 2, text: 'Review the latest category trends in Seller University.' },
  { id: 3, text: 'Ask about your brand’s monthly performance summary.' },
  { id: 4, text: 'Explore new FAQ topics to help your business grow.' },
];

function SellerUniversity() {
  const dispatch = useDispatch();
  const location = useLocation();
  const messages = useSelector((state) => state.chat.messages);
  const status = useSelector((state) => state.chat.status);
  const error = useSelector((state) => state.chat.error);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);

  useEffect(() => {
    // Optionally clear chat on mount
    // dispatch(clearChat());
  }, [dispatch]);

  const handleSend = (msg) => {
    dispatch(addUserMessage(msg));
    dispatch(sendMessageAsync({ messages, input: msg }));
  };

  return (
    <div className={styles.page}>
      <div style={{ width: '100%', background: '#004443', color: '#e4dbd2', borderRadius: '0 0 12px 12px', boxShadow: '0 2px 8px rgba(60,60,90,0.08)', padding: '1.1rem 0 0.7rem 0', margin: 0, textAlign: 'center', fontSize: '1rem', fontWeight: 500, letterSpacing: '0.5px' }}>
        Seller University is your AI-powered business coach. Get personalized recommendations, category trends, brand performance summaries, FAQs, and actionable insights. Paid brands unlock deeper analytics, more prompts, and video summaries. Use the chat below to ask questions or click a suggested question to get started!
      </div>
      <div style={{ width: '100%', height: 'calc(100vh - 64px - 4rem)', marginTop: 0 }}>
        <ChatInterface
          messages={messages}
          onSend={handleSend}
          suggestedQuestions={SUGGESTED_QUESTIONS}
          recommendations={RECOMMENDATIONS}
        />
        {status === 'loading' && <div>Sending...</div>}
        {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
    </div>
  );
}

export default SellerUniversity;
